import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { commitMutation } from 'relay-runtime'
import cookies from 'js-cookie'
import { store, IStore } from '@src/store'
import { WalletConstant } from '@src/reducers/wallet.reducer'
import { updateUserPreferenceMutation } from '@src/queries/__generated__/updateUserPreferenceMutation.graphql'
import { updateUserPreference } from '@src/queries/updateUserPreference'
import { UserProp } from '@src/stores/auth/user'
import Env from '@src/RelayEnvironment'
import { useTranslation } from 'react-i18next'
import { Tab } from './WalletModal'

export const BonusComponent = ({ setTab, isBack, user, tab, setDepositAddressData }) => {
  const { t } = useTranslation()
  const canSeeOnramp = user && user.featureFlags && user.featureFlags.includes('onramp')

  if (isBack) {
    return null
  }

  if (!canSeeOnramp) {
    return (
      <button
        className={`title ${tab === Tab.bonusBalance ? 'active' : ''}`}
        onClick={() => {
          setTab(Tab.bonusBalance)
        }}
      >
        {t('wallet.walletModal.bonusBalance', 'BONUS BALANCE')}
      </button>
    )
  }

  return (
    <button
      className={`title ${tab === Tab.buyCrypto ? 'active' : ''}`}
      onClick={() => {
        setDepositAddressData(undefined)
        setTab(Tab.buyCrypto)
      }}
    >
      {t('wallet.walletModal.buyCrypto', 'Buy Crypto')}
    </button>
  )
}
